import { Navigate, Route, Routes } from 'react-router-dom'
import PipelineAuditPage from './PipelineAuditPage'
import ShadowDifferenceDetailPage from './shadow-differences/ShadowDifferenceDetailPage'
import ShadowDifferencesPage from './shadow-differences/ShadowDifferencesPage'

export default function DocumentPipelineAuditRoutes() {
    return (
        <Routes>
            <Route index element={<PipelineAuditPage />} />
            <Route path="shadow-differences" element={<ShadowDifferencesPage />} />
            <Route path="shadow-differences/:jobId" element={<ShadowDifferenceDetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
